import { render, staticRenderFns } from "./RevolvingDetail.vue?vue&type=template&id=5158ce14&scoped=true"
import script from "./RevolvingDetail.vue?vue&type=script&lang=js"
export * from "./RevolvingDetail.vue?vue&type=script&lang=js"
import style0 from "./RevolvingDetail.vue?vue&type=style&index=0&id=5158ce14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5158ce14",
  null
  
)

export default component.exports